module.exports = __webpack_public_path__ + "img/dai7.b589d5d0.png";